"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_1 = require("./token");
const source_1 = require("./source");
const syntax_1 = require("./error/syntax");
const array_merge = require('locutus/php/array/array_merge');
class TwingTokenStream {
    constructor(tokens, source = null) {
        this.current = 0;
        this.tokens = tokens;
        this.source = source ? source : new source_1.TwingSource('', '');
    }
    toString() {
        return this.tokens.map(function (token) {
            return token.toString();
        }).join('\n');
    }
    injectTokens(tokens) {
        this.tokens = array_merge(this.tokens.slice(0, this.current), tokens, this.tokens.slice(this.current));
    }
    /**
     * Sets the pointer to the next token and returns the old one.
     *
     * @return TwingToken
     */
    next() {
        this.current++;
        if (this.current >= this.tokens.length) {
            throw new syntax_1.TwingErrorSyntax('Unexpected end of template.', this.tokens[this.current - 1].getLine(), this.source);
        }
        return this.tokens[this.current - 1];
    }
    /**
     * Tests a token, sets the pointer to the next one and returns it or throws a syntax error.
     *
     * @return TwingToken|null The next token if the condition is true, null otherwise
     */
    nextIf(primary, secondary = null) {
        if (this.tokens[this.current].test(primary, secondary)) {
            return this.next();
        }
        return null;
    }
    /**
     * Tests a token and returns it or throws a syntax error.
     *
     * @return TwingToken
     */
    expect(type, value = null, message = null) {
        let token = this.tokens[this.current];
        if (!token.test(type, value)) {
            let line = token.getLine();
            throw new syntax_1.TwingErrorSyntax(`${message ? message + '. ' : ''}Unexpected token "${token_1.TwingToken.typeToEnglish(token.getType())}" of value "${token.getValue()}" ("${token_1.TwingToken.typeToEnglish(type)}" expected${value ? ` with value "${value}"` : ''}).`, line, this.source);
        }
        this.next();
        return token;
    }
    /**
     * Looks at the next token.
     *
     * @param number {number}
     *
     * @return TwingToken
     */
    look(number = 1) {
        let index = this.current + number;
        if (index >= this.tokens.length) {
            throw new syntax_1.TwingErrorSyntax('Unexpected end of template.', this.tokens[this.current + number - 1].getLine(), this.source);
        }
        return this.tokens[index];
    }
    /**
     * Tests the active token.
     *
     * @return bool
     */
    test(primary, secondary = null) {
        return this.tokens[this.current].test(primary, secondary);
    }
    /**
     * Checks if end of stream was reached.
     *
     * @return bool
     */
    isEOF() {
        return this.tokens[this.current].getType() === token_1.TwingToken.EOF_TYPE;
    }
    /**
     * @return TwingToken
     */
    getCurrent() {
        return this.tokens[this.current];
    }
    /**
     * Gets the source associated with this stream.
     *
     * @return TwingSource
     *
     * @internal
     */
    getSourceContext() {
        return this.source;
    }
}
exports.TwingTokenStream = TwingTokenStream;
